import { useContext, useMemo, createContext } from "react";
import { useParams } from "react-router-dom";
import { isEmpty } from "lodash";
import { buildStringFilter } from "services/gaDimensionsService";
import * as customDimensions from "constants/customDimensions";
import { useReportContext } from "components/ReportContext/ReportContextProvider";
import { DIMENSION_DATE, DIMENSION_EVENT_NAME } from "constants/dimensions";
import { METRIC_EVENT_COUNT } from "constants/metrics";
import * as customEvents from "constants/customEvents";
import * as ftuCategories from "constants/ftuCategories";
import { SOURCE_PLUGIT } from "constants/contentSources";

const FTUTooltipsWizardContext = createContext({
  reportRequests: null,
});

const FTUTooltipsWizardContextProvider = ({ children }) => {
  const { id: domain } = useParams();
  const { dateStrings } = useReportContext();

  const dateRanges = useMemo(() => {
    if (!dateStrings || !dateStrings[0] || !dateStrings[1]) return [];
    return [
      {
        startDate: dateStrings[0],
        endDate: dateStrings[1],
      },
    ];
  }, [dateStrings]);

  const reportRequests = useMemo(() => {
    if (isEmpty(dateRanges)) return;

    return [
      // 0: Tooltip open (by date) - denominator for merken click rate
      {
        dateRanges,
        dimensions: [
          {
            name: DIMENSION_DATE,
          },
        ],
        metrics: [
          {
            name: METRIC_EVENT_COUNT,
          },
        ],
        dimensionFilter: {
          andGroup: {
            expressions: [
              buildStringFilter(customDimensions.DIMENSION_ITEM_BRAND, domain),
              buildStringFilter(
                customDimensions.DIMENSION_ITEM_SOURCE,
                SOURCE_PLUGIT
              ),
              buildStringFilter(
                customDimensions.DIMENSION_ITEM_CATEGORY2,
                ftuCategories.CATEGORY_TOOLTIP_V1
              ),
              buildStringFilter(
                DIMENSION_EVENT_NAME,
                customEvents.EVENT_OPEN_ITEM
              ),
            ],
          },
        },
      },
      // 1: Merken Button Clicks (by date)
      {
        dateRanges,
        dimensions: [
          {
            name: DIMENSION_DATE,
          },
        ],
        metrics: [
          {
            name: METRIC_EVENT_COUNT,
          },
        ],
        dimensionFilter: {
          andGroup: {
            expressions: [
              buildStringFilter(customDimensions.DIMENSION_ITEM_BRAND, domain),
              buildStringFilter(
                customDimensions.DIMENSION_ITEM_SOURCE,
                SOURCE_PLUGIT
              ),
              buildStringFilter(
                customDimensions.DIMENSION_ITEM_CATEGORY2,
                ftuCategories.CATEGORY_TOOLTIP_V1
              ),
              buildStringFilter(
                DIMENSION_EVENT_NAME,
                customEvents.EVENT_VIEW_ITEM_CLICKED
              ),
              buildStringFilter(
                customDimensions.DIMENSION_ITEM_CATEGORY,
                ftuCategories.CATEGORY_MERKEN_BUTTON
              ),
            ],
          },
        },
      },
    ];
  }, [dateRanges, domain]);

  return (
    <FTUTooltipsWizardContext.Provider
      value={{
        reportRequests,
      }}
    >
      {children}
    </FTUTooltipsWizardContext.Provider>
  );
};

export const useFTUTooltipsWizardContext = () =>
  useContext(FTUTooltipsWizardContext);

export default FTUTooltipsWizardContextProvider;
